import wretch, { type ConfiguredMiddleware } from 'wretch'
import FormDataAddon from 'wretch/addons/formData'
import QueryStringAddon from 'wretch/addons/queryString'

import { LOCAL_STORAGE_KEY_MAP } from './constants/platform'

/* Logs all requests passing through. */
const logMiddleware: () => ConfiguredMiddleware = () => (next) => (url, opts) => {
  console.log(opts.method + '@' + url)
  return next(url, opts)
}

const decorateAuthMiddleware: () => ConfiguredMiddleware = () => (next) => (url, opts) => {
  opts.headers = {
    ...(opts.headers as Record<string, unknown>),
    accept: 'application/json',
    Authorization: localStorage.getItem(LOCAL_STORAGE_KEY_MAP.token),
  }
  return next(url, opts)
}

export const w = wretch(import.meta.env.VITE_API_BASE_URL as string)
  .addon(FormDataAddon)
  .addon(QueryStringAddon)
  .middlewares([logMiddleware(), decorateAuthMiddleware()])
  .catcher(404, (error) => {
    throw error
  })
